export const FIELDS_MAPPING = {
  groupDetails: {
    referenceNumber: "Reference number",
    name: "Group name",
    country: "Country",
    currency: "Currency",
    legalEntityName: "Legal entity",
    active: "Active group",
  },

  brandDetails: {
    nameEn: "Brand name (English)",
    nameAr: "Brand name (Arabic)",
    descriptionEn: "Description (English)",
    descriptionAr: "Description (Arabic)",
    country: "Country",
    currency: "Currency",
    active: "Active brand",
    commercialRegistration: "Registration code",
    legalEntityName: "Legal entity",
    logoUrl: "Logo",
  },

  brandContacts: {
    email: "Email",
    websiteUrl: "Website",
    socialLinks: "Social media",
    instagram: "Instagram integration",
  },

  branchDetails: {
    active: "Active branch",
    nameEn: "Branch name (English)",
    nameAr: "Branch name (Arabic)",
    legalEntityName: "Legal entity",
    googlePlaceId: "Google place ID",
    menuUrl: "Menu URL",
    bookingUrl: "Reservation URL",
    descriptionEn: "Description (English)",
    descriptionAr: "Description (Arabic)",
    phone: "Phone number",
    smsPhoneNumbers: "SMS phone numbers",
    addressEn: "Address (English)",
    addressAr: "Address (Arabic)",
    reviewSummaryEn: "Google Reviews Summary (English)",
    reviewSummaryAr: "Google Reviews Summary (Arabic)",
    areaName: "Area",
    cityName: "City",
    landmarkName: "Landmark",
    streetName: "Street",
  },

  branchHours: {
    openingHours: "Business hours (weekdays)",
  },

  branchVibes: {
    tags: "Tags",
    ambiance: "Ambiance",
    dressCode: "Dress code",
    moment: "Moments",
    priceLevel: "Price range",
    averageWaitTime: "Average wait time",
    reservationMethods: "Reservation methods",
    reservationRequired: "Reservation required",
  },

  branchAmenities: {
    Facilities: "Facilities",
    Dining: "Dining",
    Crowd: "Crowd",
    Entertainment: "Entertainment",
    Parking: "Parking",
    Payment: "Payment",
    Kids: "Kids",
    Other: "Other",
  },

  branchMedia: {
    mediaItems: "Media",
  },

  brandMenuDish: {
    salt: "Salt (g)",
    fiber: "Fiber (g)",
    nameAr: "Dish name (Arabic)",
    nameEn: "Dish name (English)",
    sodium: "Sodium (mg)",
    protein: "Protein (g)",
    caffeine: "Caffeine (mg)",
    calories: "Calories (kCal)",
    totalFat: "Total fat (g)",
    transFat: "Trans fat (g)",
    isHighSalt: "High salt content",
    spiceLevel: "Spice",
    umamiLevel: "Umami",
    addedSugars: "Added sugars (g)",
    cholesterol: "Cholesterol (mg)",
    totalSugars: "Total sugars (g)",
    carbohydrate: "Carbohydrate (g)",
    saturatedFat: "Saturated fat (g)",
    descriptionAr: "Description (Arabic)",
    descriptionEn: "Description (English)",
    sournessLevel: "Sourness",
    sweetnessLevel: "Sweetness",
    bitternessLevel: "Bitterness",
    preparationTime: "Preparation time (min)",
    walkingMinutesToBurn: "Walking minutes to burn",
    price: "Price (SAR)",
    active: "Dish active",
    branchNames: "Active branches",
    flagsAndStatusNames: "Flags & status",
    mealTimeNames: "Meal time",
    occasionNames: "Occasions",
    dietNames: "Diet",
    allergenNames: "Allergens",
    order: "Order",
    mediaItems: "Photos & Videos",
    displayOrder: "Dish order",
  },

  brandMenu: {
    cuisines: "Cuisine",
    isActive: "Publish",
    propertyNames: "Cuisine",
  },

  menuCategories: {
    nameAr: "Category name (Arabic)",
    nameEn: "Category name (English)",
    order: "Order",
  },

  branchSetup: {
    cashback: "Cashback",
    serviceType: "Service Type",
    tablesQrCode: "Tables",
    ordersOperationType: "Operations",
  },

  branchReceiptPicture: {
    branchReceiptBillNumberMedia: "Bill Number Media",
    branchReceiptOrderTotalMedia: "Order Total Media",
  },

  branchPOS: {
    type: "POS Name",
    isEnabled: "POS Integrated",
    isSettlementEnabled: "Enable Settlement",
    isBillLookupEnabled: "Bill # Lookup",
    isTableNumberLookupEnabled: "Table # Lookup",
    isTableIdLookupEnabled: "Table ID Lookup",
    tableIdMappingFileName: "Table ID mapping",
    client_id: "POS Client ID",
    branch_id: "POS Branch ID",
    tenderId: "Tender ID",
    discountId: "Discount ID",
    integrator: "Integrator",
    qrPattern: "QR pattern",
    tableNumberLength: "Max Table Number Digits",
    baseUrl: "Base URL",
    autoClose: "Auto close",
  },

  branchBoost: {
    score: "Auto score",
    overrideScore: "Override score",
    automatic: "Use automatic boost",
  },

  branchMenu: {
    cuisine: "Cuisines",
  },

  legalEntity: {
    active: "Active legal entity",
    name: "Name",
    commercialRegistration: "Commercial Registration (CR) Number",
    ibanNumber: "IBAN Number",
    VAT: "VAT Number",
    country: "Country",
    cityName: "City",
    address: "Address",
    isFundable: "Fundable Legal Entity",
    email: "Contact Email",
    phone: "Contact Phone",
    children: "Children Legal Entities",
    groups: "Linked Groups",
    brands: "Linked Brands",
    branches: "Linked Brances",
    childLegalEntityNames: "Children Legal Entities",
  },

  portalUserDetails: {
    phoneNumber: "Phone",
    firstName: "First name",
    lastName: "Last name",
    status: "User status",
    assignmentLabels: "Assigned roles",
  },

  adminUserDetails: {
    phoneNumber: "Phone",
    firstName: "First name",
    lastName: "Last name",
    status: "User status",
    adminAccessRoleName: "Role",
  },

  dinerDetails: {
    dinerStatus: "Diner status",
    tierName: "Tier",
    referralRuleNames: "Referral Rules",
  },

  collectionDetail: {
    titleEn: "Collection name (English)",
    titleAr: "Collection name (Arabic)",
    subtitleEn: "Description (English)",
    subtitleAr: "Description (Arabic)",
    type: "Type",
    order: "Order",
    active: "Active collection",
    brandNames: "Brands",
    mediaItem: "Media",
    processedMediaId: "Media",
    groupBy: "Group by",
    filters: "Filters",
  },

  faqDetails: {
    questionEn: "Question (English)",
    answerEn: "Answer (English)",
    questionAr: "Question (Arabic)",
    answerAr: "Answer (Arabic)",
    order: "FAQ order",
  },

  refundDetails: {
    status: "Refund status",
  },

  voidDetails: {
    status: "Void status",
  },

  correctionDetails: {
    status: "Correction status",
    processedByAdminId: "Processed by admin ID",
    processedAt: "Processed at",
    rejectionReason: "Rejection reason",
    createdOrderId: "Created order ID",
    createdPurchaseId: "Created purchase ID",
    createdTransactionId: "Created transaction ID",
  },

  tierDetails: {
    active: "Active",
    code: "Enum",
    labelEn: "Label (English)",
    labelAr: "Label (Arabic)",
    profileIconProcessedMediaId: "Profile icon image",
    walletProcessedMediaId: "Wallet image",
    walletMediaUrl: "Wallet image",
    profileIconMediaUrl: "Profile icon image",
  },

  referralRuleDetails: {
    active: "Active",
    name: "Name",
    type: "Type",
    inviteLimitType: "Invite Limit Type",
    configKey: "Config Key",
    inviteLimit: "Invite limit",
    expiresAt: "Expires At",
    adjustLink: "Adjust link",
    inviteLink: "Invite Link",
  },

  cashbackOverrideDetails: {
    name: "Name",
    percentage: "Cashback %",
    includeTips: "Including tips in cashback",
    includeWallet: "Including wallet payments in cashback",
    startsAt: "Start date",
    endsAt: "End date",
    targets: "Targets",
    enabled: "Enabled",
    priority: "Priority",
    archivedAt: "Archived at",
  },

  cashbackItemExclusionDetails: {
    name: "Item name",
    externalId: "Item POS ID",
    reason: "Reason",
    status: "Status",
  },

  adminTeamRole: {
    active: "Active",
    permissions: "Module permissions",
    name: "Role name",
  },

  portalTeamRole: {
    active: "Active",
    name: "Role name",
    level: "Level",
  },

  fundingTransferDetails: {
    dinerStatus: "Status",
    receivedAmount: "Transferred Amount",
    isTransferredFromBank: "Transferred",
    dateOfBankTransfer: "Transfer Date",
    bankTransferId: "Bank Transfer ID",
    startDate: "Credit Start Date",
    endDate: "Credit End Date",
    amount: "Amount",
    status: "Status",
    remainingAmount: "Remaining amount",
    cashToCreditConversionRate: "Cash to credit conversion rate",
    contractStartDate: "Contract Start Date",
    cashGranted: "Cash granted",
    requestedAmount: "Food credit",
    contractDurationMonths: "Contract duration (months)",
  },

  dinerTopUpsDetails: {
    approvedAmount: "Approved Amount (SAR)",
    topUpStatus: "Status",
  },

  tags: {
    nameEn: "Tag name (English)",
    nameAr: "Tag name (Arabic)",
    imageUrl: "Icon",
    processedMediaId: "Icon",
  },

  settlementTransfers: {},
};
